// eslint-disable-next-line import/prefer-default-export

import { INTEGRATION_VENDORS } from './IntegrationConstants';
import { prettyPrintList } from '../util/commonUtil';

export const CALENDAR_STATUS = {
  REVOKED: 'REVOKED',
  CONNECTED: 'CONNECTED',
};

const VENDOR_NAME_MAPPING = {
  [INTEGRATION_VENDORS.GMAIL]: 'Gmail',
  [INTEGRATION_VENDORS.GMAIL_V3]: 'Gmail',
  [INTEGRATION_VENDORS.GOOGLE_CALENDAR]: 'Google Calendar',
  [INTEGRATION_VENDORS.OUTLOOK]: 'Outlook Mail',
  [INTEGRATION_VENDORS.OUTLOOK_CALENDAR]: 'Outlook Calendar',
};

export const REVOKE_CALENDAR_WARNING = (vendorsList) => {
  const vendors = vendorsList.map((_vendor) => VENDOR_NAME_MAPPING[_vendor]);
  const isMultipleVendors = vendors.length > 1;

  return `Access to your ${prettyPrintList(
    vendors
  )} has been revoked. Events won’t sync until you reconnect your Calendar${
    isMultipleVendors ? 's' : ''
  } in the Integrations page.`;
};
export const REVOKE_GOOGLE_WARNING = (vendorsList) => {
  const vendors = vendorsList.map((_vendor) => VENDOR_NAME_MAPPING[_vendor]);

  return `Access to your ${prettyPrintList(
    vendors
  )} has been revoked. Emails And Events won’t sync until you reconnect your ${prettyPrintList(
    vendors
  )} Accounts in the Integrations page.`;
};

export const REQUIRED_GRANT_EMAIL_ERROR =
  'Permission granted is not sufficient, please reconnect your email with all required access.';

export const REQUIRED_GRANT_CALENDAR_ERROR =
  'Permission granted is not sufficient, please reconnect your calendar with all required access.';

export const handledErrors = ['popup_closed_by_user', 'access_denied'];

export const CALENDAR_MEETING_TYPE_MAPPING = {
  'Google Meet': 'Google Meet Meeting',
  teamsForBusiness: 'Teams For Business',
};
